module.exports = __webpack_public_path__ + "static/media/web_kanban.0f449ca8.png";